export const OrderPaths = {
	Index: {
		route: "/orders",
		path: "/orders",
	},
	Create: {
		route: "/orders/create",
		path: "/orders/create",
	},
	Detail: {
		route: "/orders/:id/detail",
		path: (id: number) => `/orders/${id}/detail`,
	},
	Edit: {
		route: "/orders/:id/edit",
		path: (id: number) => `/orders/${id}/edit`,
	},
	Payment: {
		route: "/orders/:id/payment",
		path: (id: number) => `/orders/${id}/payment`,
	},
	Invoice: {
		route: "/orders/:id/invoice",
		path: (id: number) => `/orders/${id}/invoice`,
	},
	Protocol: {
		route: "/orders/:id/protocol",
		path: (id: number) => `/orders/${id}/protocol`,
	},
	Examination: {
		route: "/orders/:id/examination",
		path: (id: number) => `/orders/${id}/examination`,
	},
	Review: {
		route: "/orders/:id/review",
		path: (id: number) => `/orders/${id}/review`,
	},
	Claim: {
		route: "/orders/:id/claim",
		path: (id: number) => `/orders/${id}/claim`,
	},
	MorningCheck: {
		route: "/orders/:id/morning-check",
		path: (id: number) => `/orders/${id}/morning-check`,
	},
};
